import type { HttpStatic } from "~/services/http/createBaseAuthHttp";
import { RootStore } from "./RootStore";
import type { QueryClient } from "@tanstack/react-query";
import type { PersistenceStatic } from "src/services/createPersistence";

export interface Environment {
  persistence: PersistenceStatic;
  baseAuthHttp: HttpStatic;
  baseHttp: HttpStatic;
  tosHttp: HttpStatic;
  queryClient: QueryClient;
}

export async function createStore(environment: Environment) {
  const rootStore = RootStore.create({}, environment);
  await rootStore.authStore.initializeAccessTokenSync();

  return rootStore;
}
